<template lang="pug">
.sidebar
  template(v-for="item in routes")
    router-link(v-if="check(item)", :to="item.path+'/'+item.children[0].path", :key="item.path")
      el-menu-item(:index="item.path+'/'+item.children[0].path")
        icon-svg(v-if="item.icon", :icon-class="item.icon")
        span {{ item.children[0].meta.desc }}
    el-submenu(
      v-if="!item.noDropdown && !item.hidden && actions.indexOf(item.meta && item.meta.actionId)>=0"
      :index="item.meta.desc"
      :key="item.path"
    )
      template(slot="title")
        icon-svg(v-if="item.icon", :icon-class="item.icon")
        span  {{ item.meta.desc }}
      template(
        v-for="child in item.children"
        v-if="!child.hidden && actions.indexOf(child.meta && child.meta.actionId) >= 0"
      )
        sidebar-item.menu-indent(
          v-if="child.children && child.children.length > 0"
          :routes="[child]"
          :key="child.name"
        )
        router-link.menu-indent(
          v-else
          :to="`${item.path}/${child.path}`"
          :key="child.name"
        )
          el-menu-item(:index="item.path+'/'+child.path") {{ child.meta.desc }}
</template>

<script>
import { getUserInfo } from '@/utils/auth';

export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    actions() {
      const { permissions } = getUserInfo();
      return [...permissions, 'ALL'];
    }
  },
  methods: {
    check(item) {
      const res = !item.hidden
        && item.noDropdown
        && item.children.length > 0
        && this.actions.indexOf(item.meta && item.meta.actionId) >= 0;
      return res;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.sidebar {
  /deep/ .el-submenu__title,
  /deep/ .el-menu-item {
    color: rgb(214, 214, 214) !important;
  }
}
.svg-icon {
  margin-right: 10px;
}
.hideSidebar .menu-indent{
  display: block;
  text-indent: 10px;
}
</style>




// WEBPACK FOOTER //
// src/views/layout/SidebarItem.vue?37d17554